import { STORE_ROLES } from '../../constants/actionTypes'

const initialState = {}

const sortRoles = roles =>
  roles.slice().sort((a, b) => {
    const aVal = ['COMMERCIAL', 'RESIDENTIAL'].indexOf(a.lob_code)
    const bVal = ['COMMERCIAL', 'RESIDENTIAL'].indexOf(b.lob_code)

    if (aVal === bVal) {
      return a.role_display_name < b.role_display_name ? -1 : 1
    } else {
      return aVal > bVal ? -1 : 1
    }
  })

const rolesReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_ROLES:
      return Object.assign({}, state, { content: sortRoles(action.content) })
    default:
      return state
  }
}

export default rolesReducer
